import React, { Component } from "react";
import { Table } from "semantic-ui-react";
import _ from "lodash";
import Address from "../searchresults/Address";
import Phone from "../searchresults/Phone";
import Ssn from "../searchresults/Ssn";

class ReportTable extends Component {
  componentDidMount() {}

  render() {
    const rows = [];
    if (this.props.title !== undefined) {
      rows.push(
        <Table.Row
          colSpan={2}
          key={`Rep_Tbl_Title_${this.props.title}`}
          className={"page-title"}
        >
          <Table.Cell>{this.props.title}</Table.Cell>
          <Table.Cell />
        </Table.Row>
      );
    }

    _.forEach(this.props.rowData, (element) => {
      if (element.customType === "address") {
        rows.push(
          <Table.Row key={`Rep_Tbl_Row_${element.key}`}>
            <Table.Cell className="text-bold">{element.key}</Table.Cell>
            <Table.Cell>
              <Address addressNode={element.value} {...this.props} />
            </Table.Cell>
          </Table.Row>
        );
      } else if (element.customType === "phone") {
        rows.push(
          <Table.Row key={`Rep_Tbl_Row_${element.key}`}>
            <Table.Cell className="text-bold">{element.key}</Table.Cell>
            <Table.Cell>
              <Phone
                phone={element.value}
                handleNewSearchClick={this.props.handleNewSearchClick}
              />
            </Table.Cell>
          </Table.Row>
        );
      } else if (element.customType === "ssn") {
        rows.push(
          <Table.Row key={`Rep_Tbl_Row_${element.key}`}>
            <Table.Cell className="text-bold">{element.key}</Table.Cell>
            <Table.Cell>
              <Ssn
                ssn={element.value}
                handleNewSearchClick={this.props.handleNewSearchClick}
              />
            </Table.Cell>
          </Table.Row>
        );
      } else {
        rows.push(
          <Table.Row key={`Rep_Tbl_Row_${element.key}`}>
            <Table.Cell className="text-bold">{element.key}</Table.Cell>
            <Table.Cell>{element.value}</Table.Cell>
          </Table.Row>
        );
      }
    });

    return (
      <Table columns={2}>
        <Table.Body>{rows}</Table.Body>
      </Table>
    );
  }
}

export default ReportTable;



// WEBPACK FOOTER //
// ./src/components/reports/ReportTable.js